var React = require('react');
var RouteHandler = require('react-router').RouteHandler;

var Invocation = require('../../api/Invocation');

var Portal = React.createClass({
  componentDidMount() {
    Invocation.partner.services()
      .then((r) => {
        const services = r.body.services.reduce((grouped, service) => {
          (grouped[service.client_id] = grouped[service.client_id] || []).push(service);
          return grouped;
        }, {})

        this.setState({
          loading: false,
          partners: r.body.partners,
          services,
        })
      })
  },

  getInitialState: function () {
    return {
      loading: true,
      services: [],
      partners: [],
    }
  },

  render: function () {
    return <RouteHandler
      {...this.props}
      loading={this.state.loading}
      services={this.state.services}
      partners={this.state.partners}
    />;
  }
})
module.exports = Portal;



// WEBPACK FOOTER //
// ./app/components/Partner/Portal.js